import { surveyInstance } from '..';

const fetchAnswers = async (id) => {
  const { data } = await surveyInstance.get(`/answers/specific/${id}`);
  return data._id ? data : null;
};

export default fetchAnswers;
